import { render, staticRenderFns } from "./generalGroup.vue?vue&type=template&id=740f11ce&scoped=true&"
import script from "./generalGroup.vue?vue&type=script&lang=js&"
export * from "./generalGroup.vue?vue&type=script&lang=js&"
import style0 from "./generalGroup.vue?vue&type=style&index=0&id=740f11ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740f11ce",
  null
  
)

export default component.exports